<template>
	<div class="thread-media-wrapper">
		<div class="thread-media">
			<div class="thread-media-heading">
				<div class="go-back" @click="close">
					<CloseIcon type="regular" />
				</div>
				<h2 class="thread-media-header">
					{{ $t('groupsettings_media_title') }}
				</h2>
			</div>

			<ul class="media-links">
				<li v-for="tab in tabs" :key="tab.type">
					<RouterLink
						:to="{
							name: 'threadmedia',
							params: { ...$route.params, type: tab.type },
						}"
						replace
						:class="{ selected: selectedTab.type === tab.type }"
					>
						{{ tab.text }}
					</RouterLink>
				</li>
			</ul>

			<div class="thread-media-content">
				<component :is="selectedTab.component" :chatId="threadId" />
			</div>
		</div>
	</div>
</template>

<script>
import GroupMediaPhotos from '@/components/GroupSettings/GroupMediaPhotos'
import GroupMediaLinks from '@/components/GroupSettings/GroupMediaLinks'
import GroupMediaFiles from '@/components/GroupSettings/GroupMediaFiles'
import GroupMediaPolls from '@/components/GroupSettings/GroupMediaPolls'
import { orgFlag, POLLS } from '@/helpers/flags'
import { CloseIcon } from '@/icons'

export default {
	name: 'ThreadMedia',
	components: { CloseIcon },
	props: {
		threadId: [String, Number],
		type: String,
	},
	computed: {
		tabs() {
			return [
				{
					type: 'photos',
					text: this.$t('groupsettings_mediatray_photos_videos_title'),
					component: GroupMediaPhotos,
				},
				{
					type: 'links',
					text: this.$t('groupsettings_mediatray_links_title'),
					component: GroupMediaLinks,
				},
				{
					type: 'files',
					text: this.$t('groupsettings_mediatray_files_title'),
					component: GroupMediaFiles,
				},
				...(orgFlag(POLLS)
					? [
							{
								type: 'polls',
								text: this.$t('groupsettings_mediatray_polls_title'),
								component: GroupMediaPolls,
							},
					  ]
					: []),
			]
		},
		selectedTab() {
			return this.tabs.find((t) => t.type === this.type) || this.tabs[0]
		},
	},
	methods: {
		close() {
			this.$router.go(-1)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

@media screen and (max-width: 1000px) {
	.thread-media-wrapper {
		left: 0px !important;
	}
}

.thread-media-wrapper {
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	left: 280px;
	background-color: var(--neutral-0);
	z-index: 7;
	padding-bottom: 40px;
}

.thread-media {
	display: flex;
	flex-direction: column;
	width: 830px;
	height: 100%;
	margin: 0 auto;
	padding: 0 20px;
}

.thread-media-heading {
	position: relative;
}

.go-back {
	position: absolute;
	left: 0;
	top: 10px;
	cursor: pointer;
	font-size: 28px;
	color: var(--neutral-400);

	&:hover {
		color: var(--neutral-500);
	}
}

.thread-media-header {
	padding-left: 20px;
	margin-bottom: 30px;
	font-family: Avenir-Heavy;
	font-size: 30px;
	font-weight: normal;
	line-height: 1.2;
	text-align: center;
	color: var(--neutral-800);
}

.media-links {
	display: flex;
	align-items: stretch;
	justify-content: space-between;
	width: 100%;
	margin: 8px 0 10px 0;
	padding: 0 15px 20px 0;
}

.media-links li {
	display: block;
	flex: 0 1 auto;
	list-style-type: none;
}

.media-links a {
	text-decoration: none;
	font-family: Avenir-Heavy;
	font-size: 16px;
	line-height: 0.82;
	letter-spacing: -0.1px;
	color: var(--neutral-800);
}

.media-links a.selected {
	color: var(--teal-300);
	text-decoration: underline;
}

.media-links a:hover {
	color: var(--teal-300);
	text-decoration: underline;
}

.thread-media-content {
	flex: 1;
	overflow-y: auto;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.thread-media-wrapper {
		background-color: var(--neutral-100);
	}
}
</style>
